import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Form, getIn } from "formik";
import {
  VStack,
  HStack,
  Text,
  Button,
  Flex,
  Divider,
  Badge,
} from "@chakra-ui/react";
import { StepProps } from "../../../../../../utils/types/step";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../../redux/reducer/rootReducer";
import * as Yup from "yup";
import StepHeader from "../../../../../../components/StepperHeader";
import { AddIcon, ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import { saveFormData } from "../../../../../../redux/slice/formSlice";
import { color } from "../../../../../../utils/theme";
import { FaPlusCircle } from "react-icons/fa";
import AppDrawer from "../../../../../../components/drawer";
import Measurement from "../../../../../../components/measurment";
import { Option } from "../../../../../../utils/types/props.dropdown";
import {
  MeasurementType,
  MeasurementTypes,
} from "../../../../../../utils/types/measurment";
const oneToFiveOptions = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
];

export interface ProjectMeasurementProps {
  changeIdea: string;
  processMeasure: MeasurementType[];
  balancingMeasure: MeasurementType[];
}
export interface Measurements {
  measurements: ProjectMeasurementProps[];
}

const ProjectMeasurment = (props: StepProps) => {
  const measurementData = useSelector(
    (state: RootState) => state.form.formData["9"]
  );

  const aimStatementData = useSelector(
    (state: RootState) => state.form.formData["3"]
  );

  const [showAddMeasurementModal, setShowAddMeasurementModal] = useState(false);
  const onClose = () => setShowAddMeasurementModal(false);
  const onOpen = () => setShowAddMeasurementModal(true);

  const [viewChangeIdeas, setViewChangeIdeas] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedChangeIdea, setSelectedChangeIdea] = useState<string>("");
  const [selectedMeasurementType, setSelectedMeasurementType] =
    useState<MeasurementTypes>(MeasurementTypes.Outcome);
  const [currentMeasurement, setCurrentMeasurement] =
    useState<MeasurementType>();
  const handleSubmit = (values: any) => {
    console.log("Inside handle submit");

    console.log("project measurement form data: ", values.measurements);

    let data = values.measurements.map((value: ProjectMeasurementProps) => {
      return {
        changeIdea: value.changeIdea,
        processMeasure: value.processMeasure,
        balancingMeasure: value.balancingMeasure,
      };
    });

    console.log("prioritize data: ", data);

    dispatch(saveFormData({ step: "9", data: data }));

  };

  const [initialValues, setInitialValues] = useState<Measurements>({
    measurements: [
      {
        changeIdea: "",
        processMeasure: [],
        balancingMeasure: [],
      },
    ],
  });
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const changeIdeaData = useSelector(
    (state: RootState) => state.form.formData["7"]
  );

  const schema = Yup.object().shape({
    measurements: Yup.array().of(
      Yup.object().shape({
        changeIdea: Yup.string().required("Change Idea is required"),
        processMeasure: Yup.array()
          .of(
            Yup.object().shape({
              changeIdea: Yup.string().required("Process Measure is required"),
            })
          )
          .required("Required"),
        balancingMeasure: Yup.array()
          .of(
            Yup.object().shape({
              changeIdea: Yup.string().required(
                "Balancing Measure is required"
              ),
            })
          )
          .required("Required"),
      })
    ),
  });

  useEffect(() => {
    let mappedProjectMeasurements: ProjectMeasurementProps[] = [];

    // Check if prioritizeData has entries
    if (measurementData && Object.values(measurementData).length > 0) {
      console.log("prioritize data: ", measurementData);

      // Map prioritizeData into ProblemRanking format
      mappedProjectMeasurements = Object.values(measurementData).map(
        (measurement: ProjectMeasurementProps) => ({
          changeIdea: measurement.changeIdea,
          processMeasure: measurement.processMeasure,
          balancingMeasure: measurement.balancingMeasure,
        })
      );
    } else {
      // Fallback when prioritizeData is empty
      const changeIdeaArray = Object.values(changeIdeaData);

      mappedProjectMeasurements = changeIdeaArray.flatMap((changeIdea: any) =>
        changeIdea.changeIdea.map((change: string) => ({
          changeIdea: change || "",
          processMeasure: [] as string[],
          balancingMeasure: [] as string[],
        }))
      );
    }
    console.log("mapped secondary causes: ", mappedProjectMeasurements);

    // Update initial values with the final mapped secondary causes
    const updatedInitialValues = {
      measurements: [...mappedProjectMeasurements],
    };

    console.log("updated initial values: ", updatedInitialValues);

    setInitialValues(updatedInitialValues);
  }, [measurementData, changeIdeaData]); // Add dependencies for reactivity

  const [dataTypes] = useState<Option[]>([
    { label: "Percentage", value: "Percentage" },
    { label: "Number", value: "Number" },
  ]);

  const [measurment, setMeasurment] = useState<MeasurementType[]>([]);
  const [viewMeasurement, setViewMeasurement] = useState(false);

  const [frequency] = useState<Option[]>([
    { label: "Daily", value: "Daily" },
    { label: "Every otherday", value: "every otherday" },
    { label: "Weekly", value: "weekly" },
    { label: "Bi weekly", value: "biweekly" },
  ]);

  const [outcomeMeasure, setOutcomeMeasure] = useState<MeasurementType>();

  const handleMeasurementAdded = (values: MeasurementType) => {
    const { measurmentType } = values;

   
    const updatedMeasurements = [...initialValues.measurements];

    const fieldToUpdate =
      measurmentType === MeasurementTypes.Process
        ? "processMeasure"
        : measurmentType === MeasurementTypes.Balancing
        ? "balancingMeasure"
        : measurmentType === MeasurementTypes.Outcome
        ? "outcomeMeasure"
        : null;

    if (!fieldToUpdate) {
      console.error(`Unknown measurementType: ${measurmentType}`);
      return;
    }

    if (fieldToUpdate === "outcomeMeasure") {
      setOutcomeMeasure(values);
      onClose();
      return;
    }

    if (!updatedMeasurements[selectedIndex][fieldToUpdate]) {
      updatedMeasurements[selectedIndex][fieldToUpdate] = [];
    }

    updatedMeasurements[selectedIndex][fieldToUpdate].push(values);

    setInitialValues({ measurements: updatedMeasurements });

    onClose();
  };

  const handleMeasurementUpdated = (values: MeasurementType) => {
    onClose();
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 10);
  }, [initialValues]);

  return (
    <>
      {showAddMeasurementModal && (
        <AppDrawer
          placement="right"
          title={selectedMeasurementType}
          size="lg"
          children={
            <Measurement
              changeIdea={selectedChangeIdea}
              dataType={dataTypes}
              measurementType={selectedMeasurementType}
              frequency={frequency}
              onSubmit={handleMeasurementAdded}
              onCancel={onClose}
              onUpdated={handleMeasurementUpdated}
              measurement={currentMeasurement}
            />
          }
          onClose={() => setShowAddMeasurementModal(false)}
        />
      )}

      {viewMeasurement && (
        <AppDrawer
          placement="right"
          title="View Measurement"
          size="lg"
          children={
            <VStack spacing={4}>
              {measurment.map((measure: MeasurementType, index) => (
                <VStack
                  w={"100%"}
                  borderBottomWidth={1}
                  borderTopWidth={1}
                  key={index}
                  paddingBottom={3}
                  paddingTop={3}
                >
                  <HStack
                    w="100%"
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                  >
                    <Text
                      fontSize={18}
                      pl={4}
                      fontWeight={"700"}
                      color={color.text}
                    >
                      Name: {measure.name}
                    </Text>
                    <Text
                      fontSize={18}
                      pl={4}
                      fontWeight={"700"}
                      color={color.text}
                    >
                      Data Type: {measure.dataType}
                    </Text>
                  </HStack>
                  <HStack
                    w="100%"
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                  >
                    <Text
                      fontSize={18}
                      pl={4}
                      fontWeight={"700"}
                      color={color.text}
                    >
                      Frequency: {measure.frequency}
                    </Text>
                    <Text
                      fontSize={18}
                      pl={4}
                      fontWeight={"700"}
                      color={color.text}
                    >
                      Measurement Type: {measure.measurmentType}
                    </Text>
                  </HStack>
                  <HStack
                    w="100%"
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                  >
                    <Text
                      fontSize={18}
                      pl={4}
                      fontWeight={"700"}
                      color={color.text}
                      display={"flex"}
                      gap={3}
                      flexDirection={"row"}
                    >
                      Baseline: {measure.baseline}
                    </Text>
                    <Text
                      fontSize={18}
                      pl={4}
                      textAlign={"left"}
                      fontWeight={"700"}
                      color={color.text}
                    >
                      Target: {measure.target}
                    </Text>
                  </HStack>
                </VStack>
              ))}
            </VStack>
          }
          onClose={() => setViewMeasurement(false)}
        />
      )}
      {initialValues.measurements?.length === 0 || loading ? (
       <Text>...loading</Text>
      ) : (
        <>
          <StepHeader
            title="Project Measurements"
            description="In this Section, we will be defining our measurement. 
Let us start with Outcome Measure, which measures our Aim Statement.
"
          />

          <HStack
            display="flex"
            flexDirection="row"
            justifyContent={"space-between"}
            w="full"
            gap={10}
            py={5}
            borderRadius={5}
            my={4}
          >
            <VStack
              alignContent={"flex-start"}
              alignItems={"flex-start"}
              border={"1px solid #E2E8F0"}
              borderRadius={5}
              p={5}
              gap={3}
              w={"full"}
            >
              <Text fontWeight={"bold"} fontSize={22} color={color.primary}>
                Project Aim Statement
              </Text>
              <Text flex={0.5} fontSize={18} textAlign={"left"}>
                {aimStatementData?.aimStatement}
              </Text>
              <Divider />
              <HStack>
                <Button
                  colorScheme="blue"
                  leftIcon={<FaPlusCircle />}
                  onClick={() => {
                    setSelectedMeasurementType(MeasurementTypes.Outcome);
                    setShowAddMeasurementModal(true);
                  }}
                >
                  Add Outcome Measure
                </Button>
                {outcomeMeasure && (
                  <Button
                    colorScheme="blue"
                    variant={"outline"}
                    onClick={() => {
                      setMeasurment([outcomeMeasure]);
                      setSelectedMeasurementType(MeasurementTypes.Outcome);
                      setViewMeasurement(true);
                    }}
                  >
                    View Outcome Measure
                  </Button>
                )}
              </HStack>
            </VStack>
          </HStack>
          <Divider my={5} />
          <HStack
            display="flex"
            flexDirection="row"
            w="full"
            gap={10}
            px={5}
            borderRadius={5}
            py={4}
            backgroundColor={"gray.50"}
          >
            <Text flex={0.1} textAlign={"left"}>
              #
            </Text>
            <Text flex={0.2} textAlign={"left"}>
              Change Ideas
            </Text>

            <Text flex={0.4} textAlign={"left"}>
              Process Measure
            </Text>

            <Text flex={0.4} textAlign={"left"}>
              Balancing Measure
            </Text>
          </HStack>
          <Formik
            initialValues={initialValues}
            validateOnBlur={true}
            validationSchema={schema}
            onSubmit={handleSubmit}
          >
            {({ values, errors, isValid, handleChange, touched }) => {
              console.log("is form valid: ", isValid);

              return (
                <Form>
                  <FieldArray
                    name="measurements"
                    render={({ remove, push }) => (
                      <>
                        {values.measurements.map(
                          (
                            projectMeasurements: ProjectMeasurementProps,
                            index: number
                          ) => (
                            <React.Fragment key={index}>
                              <HStack
                                key={`${index}-${projectMeasurements}`}
                                display="flex"
                                flexDirection="row"
                                w="full"
                                p={4}
                                gap={10}
                                borderColor="gray.100"
                                borderWidth={1}
                                borderRadius={5}
                                m={1}
                              >
                                <Flex flex={0.1} direction={"row"} gap={2}>
                                  <Text>{index + 1}</Text>
                                </Flex>
                                <Flex flex={0.2} direction={"row"} gap={2}>
                                  <Text textAlign={"left"}>
                                    {typeof projectMeasurements.changeIdea === 'string' ? projectMeasurements.changeIdea : JSON.stringify(projectMeasurements.changeIdea)}
                                  </Text>
                                </Flex>

                                <HStack flex={0.4}>
                                  <Button
                                    alignSelf={"flex-start"}
                                    colorScheme="blue"
                                    size={"sm"}
                                    leftIcon={<AddIcon />}
                                    onClick={() => {
                                      setSelectedChangeIdea(
                                        projectMeasurements.changeIdea
                                      );
                                      setSelectedMeasurementType(
                                        MeasurementTypes.Process
                                      );
                                      setShowAddMeasurementModal(true);
                                      setSelectedIndex(index);
                                    }}
                                  >
                                    Add Process Measures
                                  </Button>
                                  {projectMeasurements.processMeasure.length >
                                    0 && (
                                    <Button
                                      colorScheme="blue"
                                      variant={"outline"}
                                      onClick={() => {
                                        setMeasurment(
                                          projectMeasurements.processMeasure
                                        );
                                        setViewMeasurement(true);
                                      }}
                                      size={"sm"}
                                      rightIcon={
                                        <Badge ml="1" colorScheme="green">
                                          {
                                            projectMeasurements.processMeasure
                                              .length
                                          }
                                        </Badge>
                                      }
                                    >
                                      View Process Measures
                                    </Button>
                                  )}
                                  {getIn(
                                    errors,
                                    `measurements[${index}].processMeasure`
                                  ) && (
                                    <Text color="red" fontSize="sm">
                                      {getIn(
                                        errors,
                                        `measurements[${index}].processMeasure`
                                      )}
                                    </Text>
                                  )}
                                </HStack>
                                <HStack flex={0.45} align="stretch">
                                  <VStack>
                                    <HStack>
                                      <Button
                                        alignSelf={"flex-start"}
                                        colorScheme="blue"
                                        size={"sm"}
                                        leftIcon={<AddIcon />}
                                        onClick={() => {
                                          setSelectedChangeIdea(
                                            projectMeasurements.changeIdea
                                          );
                                          setSelectedMeasurementType(
                                            MeasurementTypes.Balancing
                                          );
                                          setShowAddMeasurementModal(true);
                                          setSelectedIndex(index);
                                        }}
                                      >
                                        Add Balancing Measures
                                      </Button>
                                      {projectMeasurements.balancingMeasure
                                        .length > 0 && (
                                        <Button
                                          colorScheme="blue"
                                          variant={"outline"}
                                          onClick={() => {
                                            setMeasurment(
                                              projectMeasurements.balancingMeasure
                                            );
                                            setViewMeasurement(true);
                                          }}
                                          size={"sm"}
                                          rightIcon={
                                            <Badge ml="1" colorScheme="green">
                                              {
                                                projectMeasurements
                                                  .balancingMeasure.length
                                              }
                                            </Badge>
                                          }
                                        >
                                          View Balancing Measures
                                        </Button>
                                      )}
                                    </HStack>
                                    {getIn(
                                      errors,
                                      `measurements[${index}].balancingMeasure`
                                    ) && (
                                      <Text color="red" fontSize="sm">
                                        {getIn(
                                          errors,
                                          `measurements[${index}].balancingMeasure`
                                        )}
                                      </Text>
                                    )}
                                  </VStack>
                                </HStack>
                              </HStack>
                            </React.Fragment>
                          )
                        )}
                      </>
                    )}
                  />
                  <HStack
                    flex={0.1}
                    w="100%"
                    mt={5}
                    justifyContent="space-between"
                    p={4}
                    bg="gray.50"
                  >
                    <Button
                      colorScheme="blue"
                      variant="outline"
                      leftIcon={<ArrowLeftIcon />}
                      onClick={() => {
                        if (props.onPrev) {
                          props.onPrev();
                        }
                      }}
                    >
                      Previous
                    </Button>
                    <HStack>
                      <Button
                        isDisabled={!isValid || !touched}
                        colorScheme="blue"
                        variant="outline"
                      >
                        Save & Exit
                      </Button>
                      <Button
                        isDisabled={!isValid || !touched}
                        colorScheme="blue"
                        type="submit"
                        w={"50%"}
                        rightIcon={<ArrowRightIcon />}
                      >
                        Next
                      </Button>
                    </HStack>
                  </HStack>
                </Form>
              );
            }}
          </Formik>
        </>
      )}
    </>
  );
};

export default ProjectMeasurment;
